"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Appends new elements to an array, and returns the new length of the array.
 * @param array base Array
 * @param items New elements of the Array.
 */
function push(array) {
    var items = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        items[_i - 1] = arguments[_i];
    }
    return array.concat(items);
}
exports.push = push;
//# sourceMappingURL=push.js.map


//////////////////
// WEBPACK FOOTER
// /home/travis/build/proofdict/proofdict/node_modules/@immutable-array/push/lib/push.js
// module id = 967
// module chunks = 0